import { DeleteJob } from 'api/jobs-endpoint';
import ConfirmButton from 'components/ConfirmButton';
import useOperationAuthorizationChecks from 'hooks/useOperationAuthorizationChecks';
import { ADMIN_JOB_CREATE } from 'navigator/links';
import { useNavigate, useParams } from 'react-router-dom';
import { useJobsContext } from 'stores/jobs-context';
import { Job } from 'types/job';
import { UserOperations } from 'types/user';

interface DeleteJobButtonProps {
  job: Job;
  className?: string;
  onDeleteFail: (message: string) => void;
}

function DeleteJobButton({ job, className, onDeleteFail }: DeleteJobButtonProps): JSX.Element {
  const jobsContext = useJobsContext();
  const navigate = useNavigate();
  const canDeleteJob = useOperationAuthorizationChecks([UserOperations.JOB_DELETE]);

  if (!canDeleteJob) {
    return <></>;
  }

  const handleClick = async () => {
    const response = await DeleteJob(job);
    if (response.success) {
      jobsContext.fetchData();
      navigate(ADMIN_JOB_CREATE);
    } else {
      onDeleteFail(response.message || '');
    }
  };

  return <ConfirmButton label='Delete Job' onClick={handleClick} className={className} />;
}

DeleteJobButton.defaultProps = {
  className: undefined,
};

export default DeleteJobButton;
